<template>
    <div class="bg p-3 pb-6">
        <div class="form-columns-fit mb-4">
            <div class="columns is-flex-wrap">
                <div class="column is-half is-full-mobile">
                    <verified-date-picker
                        dateType="startDate"
                        :value="dataInicial"
                        :endDate="dataFinal"
                        title="data-inicio-check-in"
                        @input="changeStartDate"
                        :showClean="false"
                        :invalid="dataInicial == null"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <verified-date-picker
                        dateType="endDate"
                        :value="dataFinal"
                        :startDate="dataInicial"
                        title="data-final-check-in"
                        @input="changeEndDate"
                        :showClean="false"
                        :invalid="dataFinal == null"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="cliente"
                        :value="clienteSelected"
                        :options="clienteList"
                        :loading="clienteLoading"
                        @search="carregarClientes"
                        @input="updateCliente"
                        label="nome"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="no-cliente"
                        :value="checkInNoCliente"
                        :options="yesNoOptions"
                        @input="updateNoCliente"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="cliente-com-geolocalizacao"
                        :value="clienteHasGeolocalizacao"
                        :options="yesNoOptions"
                        @input="updateClienteGeolocalizacao"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="check-in-com-geolocalizacao"
                        :value="checkInHasGeolocalizacao"
                        :options="yesNoOptions"
                        @input="updateCheckInGeolocalizacao"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filtersReset: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dataInicial: new Date(this.$moment().subtract(30, 'days')),
            dataFinal: new Date(),

            clienteList: [],
            clienteSelected: [],
            clienteLoading: false,

            yesNoOptions: [
                {
                    id: 2,
                    label: this.$t('todos')
                },
                {
                    id: 1,
                    label: this.$t('sim')
                },
                {
                    id: 0,
                    label: this.$t('nao')
                },
            ],
            yesNoDefaultValue: {
                id: 2,
                label: this.$t('todos')
            },
            checkInNoCliente: null,
            clienteHasGeolocalizacao: null,
            checkInHasGeolocalizacao: null,
        };
    },
    created() {
        this.checkInNoCliente = this.yesNoDefaultValue;
        this.clienteHasGeolocalizacao = this.yesNoDefaultValue;
        this.checkInHasGeolocalizacao = this.yesNoDefaultValue;
    },
    watch: {
        filtersReset(val) {
            if (val) this.clearFilter();
        },
    },
    methods: {
        changeStartDate(date) {
            if (date.getTime() != this.dataInicial.getTime()) {
                this.dataInicial = date;
                if (!this.isNull(this.dataInicial)) {
                    this.$emit('update-filtro', {
                        nomeFiltro: 'dataInicial',
                        valor: this.dataInicial,
                    });
                }
            }
        },
        changeEndDate(date) {
            if (date.getTime() != this.dataFinal.getTime()) {
                this.dataFinal = date;
                if (!this.isNull(this.dataFinal)) {
                    this.$emit('update-filtro', {
                        nomeFiltro: 'dataFinal',
                        valor: this.dataFinal,
                    });
                }
            }
        },
        carregarClientes(searchQuery) {
            this.clienteLoading = true;
            this.$axios
                .get(`/cliente/list.json`, {
                    params: {
                        limit: 250,
                        param: searchQuery,
                    },
                })
                .then((response) => {
                    this.clienteList = response.data.content.map((c) => {
                        return {
                            id: c.idcliente,
                            nome: c.nome,
                        };
                    });
                })
                .catch(() => {
                    this.clienteList = [];
                })
                .finally(() => {
                    this.clienteLoading = false;
                });
        },
        updateCliente(cliente) {
            this.clienteSelected = cliente;
            this.$emit('update-filtro', {
                nomeFiltro: 'idClienteList',
                valor:
                    this.clienteSelected.length == 0 ? [] : this.clienteSelected.map((c) => c.id),
            });
        },
        updateNoCliente(valueSelected) {
            this.checkInNoCliente = valueSelected;

            this.$emit('update-filtro', {
                nomeFiltro: 'checkInNoCliente',
                valor: this.checkInNoCliente.id,
            });
        },
        updateClienteGeolocalizacao(valueSelected) {
            this.clienteHasGeolocalizacao = valueSelected;

            this.$emit('update-filtro', {
                nomeFiltro: 'clienteHasGeolocalizacao',
                valor: this.clienteHasGeolocalizacao.id,
            });
        },
        updateCheckInGeolocalizacao(valueSelected) {
            this.checkInHasGeolocalizacao = valueSelected;
            
            this.$emit('update-filtro', {
                nomeFiltro: 'checkInHasGeolocalizacao',
                valor: this.checkInHasGeolocalizacao.id,
            });
        },

        clearFilter() {
            this.dataInicial = new Date(this.$moment().subtract(30, 'days'));
            this.dataFinal = new Date();
            this.updateCliente([]);
            
            this.updateNoCliente(this.yesNoDefaultValue);
            this.updateClienteGeolocalizacao(this.yesNoDefaultValue);
            this.updateCheckInGeolocalizacao(this.yesNoDefaultValue);
        },
    },
};
</script>
